import { Component, Input, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { switchMap, finalize } from 'rxjs/operators';

@Component({
  selector: 'wm-renewals-janus-renew',
  standalone: false,
  templateUrl: './renewals-janus-renew.component.html',
  styleUrls: ['./renewals-janus-renew.component.scss']
})
export class RenewalsJanusRenewComponent implements OnInit {

  private _row: any;
  private initializedForRow = false;
  private loadedChildApplicationId: string | null = null;

  @Input()
  set row(value: any) {
    this._row = value;
    this.tryInitialize();
  }
  get row(): any {
    return this._row;
  }
  @Input() closeExpansion!: () => void;

  isLoading = false;
  navigateToStepperForm = false;

  applicationId!: string;
  activityDataId!: string;
  workflowId!: string;
  workflowVersionId!: string;
  isTestApplication!: boolean;

  constructor(
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.tryInitialize();
    this.route.queryParamMap.subscribe(params => {
      const childApplicationId =
        params.get('isChild') === '1' ? params.get('cid') : null;

      if (!childApplicationId) {
        this.loadedChildApplicationId = null;
        return;
      }

      if (childApplicationId === this.loadedChildApplicationId) {
        return;
      }

      this.loadedChildApplicationId = childApplicationId;
      this.prepareChildWorkflow(childApplicationId);
    });
  }

  private prepareChildWorkflow(applicationId: string): void {
    this.isLoading = true;
    this.navigateToStepperForm = false;

    this.dataService
      .isWorkflowApplicationInProgress(applicationId)
      .pipe(
        switchMap(() =>
          this.dataService.getCurrentApplicationActivity(applicationId)
        ),
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: () => {
          this.navigateToStepperForm = true;
        },
        error: err => {
          console.error(err);
          this.navigateToStepperForm = true;
        }
      });
  }

  private tryInitialize(): void {
    if (this.initializedForRow) {
      return;
    }

    if (!this.row?.id) {
      console.error('Registration ID missing');
      return;
    }

    this.initializedForRow = true;
    this.startRenewFlow();
  }

  private startRenewFlow(): void {

    this.isLoading = true;

    this.dataService
      // 1️⃣ Start renewal using registrationId
      .startRegistrationRenewal(
        this.row.id,
        'false',   // service expects string
        null
      )

      // 2️⃣ Use returned applicationId
      .pipe(
        switchMap((startRes: any) => {

          this.applicationId = startRes.applicationId;

          return this.dataService
            .isWorkflowApplicationInProgress(this.applicationId);
        }),

        // 3️⃣ Get current activity
        switchMap(() => {
          return this.dataService
            .getCurrentApplicationActivity(this.applicationId);
        }),

        finalize(() => this.isLoading = false)
      )

      .subscribe({
        next: (response: any) => {

          let activityDataId: string | undefined;

          if (response.activity?.activityDataId) {
            activityDataId = response.activity.activityDataId;
          } else {
            const formActivity = response.navigationActivities
              ?.find((a: any) => a.activityType === 'form-activity');

            if (!formActivity) {
              console.error('No form activity found');
              return;
            }

            activityDataId = formActivity.activityDataId;
          }

          if (!activityDataId) return;

          this.activityDataId = activityDataId;
          this.workflowId = response.workflowId;
          this.workflowVersionId = response.workflowVersionId;
          this.isTestApplication = response.isTestApplication;

          // ✅ Set required query params like InlineApplicationsCardComponent
          const currentPage = Number(this.route.snapshot.queryParamMap.get('p') ?? 0);
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              p: Number.isNaN(currentPage) ? 0 : currentPage,
              id: this.applicationId,
              registrationId: this.row.id,
              activityDataId: this.activityDataId,
              workflowId: this.workflowId,
              workflowVersionId: this.workflowVersionId,
              isTest: this.isTestApplication,
              showAppView: 1
            },
            queryParamsHandling: 'merge'
          });

          // Render stepper inline
          this.navigateToStepperForm = true;
        },

        error: err => {
          console.error(err);
        }
      });
  }
}
